import type { ReactElement } from "react";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { SIHoorayOnboardingGif } from "app/pages/sales-intelligence/constants/images";
import {
    StyledOnboardingHubBodyCompleted,
    StyledOnboardingHubCompletedSubTitle,
    StyledOnboardingHubCompletedTitle,
    StyledOnboardingHubHoorayWrapper,
    StyledSidebarOnboardingHubCompletedTitle,
    StyledSidebarOnboardingHubHoorayWrapper,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubCompleted/styles";
import { StyledOnboardingHubContentBodyWrapper } from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/containers/styles";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

interface OnboardingHubCompletedProps {
    isInSidebar: boolean;
}
const OnboardingHubCompleted = ({ isInSidebar }: OnboardingHubCompletedProps): ReactElement => (
    <>
        {isInSidebar ? (
            <StyledSidebarOnboardingHubHoorayWrapper>
                <SWReactIcons
                    iconName="rocket"
                    size="xs"
                    iconColor={colorsPalettes.carbon[400]}
                />
                <I18n
                    translatable={{ key: "si.onboarding.hub.sidebar.completed.title" }}
                    element={StyledSidebarOnboardingHubCompletedTitle}
                />
            </StyledSidebarOnboardingHubHoorayWrapper>
        ) : (
            <StyledOnboardingHubContentBodyWrapper>
                <StyledOnboardingHubHoorayWrapper>
                    <img
                        alt="You did it!"
                        width="264"
                        src={SIHoorayOnboardingGif}
                    />
                </StyledOnboardingHubHoorayWrapper>
                <StyledOnboardingHubBodyCompleted>
                    <I18n
                        translatable={{ key: "si.onboarding.hub.completed.title" }}
                        element={StyledOnboardingHubCompletedTitle}
                    />
                    <I18n
                        translatable={{ key: "si.onboarding.hub.completed.subtitle" }}
                        element={StyledOnboardingHubCompletedSubTitle}
                    />
                </StyledOnboardingHubBodyCompleted>
            </StyledOnboardingHubContentBodyWrapper>
        )}
    </>
);

export default OnboardingHubCompleted;
